export default __webpack_public_path__ + "img/job-data.ac463b.svg";